<template>
    <div class='section-intro border-bottom padding-bottom'>

        <div class="main-area padding-top single-content">

            <router-link v-if='location["verdieping-mapping"] || location["verdieping-programma"] || location["verdieping-links-naar-meer"] || location["verdieping-archief"] || location["verdieping-essays"] || location["verdieping-klankbordgroep"]'
                         :to="{name: 'verdieping', params: {language: language}}"
                         class='strong'>
                <span v-if='language === "nl"'>&#60; Verdieping</span>
                <span v-if='language === "en"'>&#60; Context</span>
            </router-link>
            <span v-if='language === "nl" && loaded.posts'
                  v-html='introNL'></span>
            <span v-if='language === "en" && loaded.posts'
                  v-html='introEN'></span>

            <div v-if='location.programma && "loaded.filters"'
                 class='filters secondary-color large-text'>
                <div @click='resetFilter'
                     class='filter-item strong'>Filter</div>
                <dsFilterItem class='filter-item'
                              v-for='item in filters'
                              :item="item"
                              :language="language"></dsFilterItem>
            </div>

        </div>

        <dsTags v-if='screenSize.mobile === false && loaded.tags'
                class='secondary-area'
                :language='language'
                :tags='tags'>
        </dsTags>

    </div>
</template>

<script>
import dsTags from './dsTags'
import dsFilterItem from './dsFilterItem'
import globalgrid from '../globalGrid'

export default {
  name: 'dsSectionIntro',
  components: {
    dsTags,
    dsFilterItem
  },
  props: ['language', 'tags', 'loaded', 'introNL', 'introEN', 'screenSize', 'location', 'filters'],
  methods: {
    resetFilter() {
      globalgrid.grid.arrange({
        filter: '*'
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
@import '../styles/_typography.scss';
.section-intro {
  width: 100%;
  height: 44 * $baseline;
  position: relative;
  @include screen-size ('x-small') {
    overflow: hidden;
    height: auto;
    display: inline-block;
  }
}
.main-area {
  width: 2 * $column + $margin;
  float: left;
  height: 41 * $baseline;
  a {
    border: 0;
  }
  @include screen-size ('medium') {
    // width: $column;
    width: 2 * $column + $margin;
    height: 20 * $baseline;
  }
  @include screen-size ('x-small') {
    width: 100%;
    height: auto;
    display: inline-block;
  }
}
.secondary-area {
  float: left;
  height: 100%;
  margin-left: $margin;
  width: $column;
  @include screen-size ('x-small') {
    margin-left: 0;
    margin-top: $baseline;
    width: 100%;
  }
}
.filters {
  position: absolute;
  bottom: 2 * $baseline;
  height: 14 * $baseline;
  border: 1px solid $secondary-color;
  width: 2 * $column + $margin;
  @include screen-size ('medium') {
    display: none;
  }
  .filter-header {
    float: left;
    height: 16 * $baseline;
    width: 16%;
    line-height: 2 * $baseline;
    padding: $baseline;
    font-size: $small-text;
    &:hover {
      color: $high-light;
      cursor: pointer;
    }
  }
  .filter-item {
    float: left;
    padding: $baseline;
    line-height: 2 * $baseline;
    // height:  5 * $baseline;
    width: 20%;
    font-size: $small-text;
    text-transform: uppercase;
    &:hover {
      color: $high-light;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// dsSectionIntro.vue?625ea27a